import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'mutara-data-dump',
    templateUrl: './data-dump.component.html',
    styleUrls: ['./data-dump.component.scss'],
    standalone: false
})
export class DataDumpComponent extends FieldWrapper implements OnInit {

  formData : any = []; 
  constructor(private http : HttpClient) {
    super();
   }

  ngOnInit(): void {
  }
  sendChange($event) {
    console.log(`Sending data ${JSON.stringify($event)}`);
  }
}
